/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable consistent-return */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { MdOutlineKeyboardArrowRight } from 'react-icons/md';
import AppSelect from '../../shared/components/app-select/AppSelect';
import AppTextInput from '../../shared/components/app-text-input/AppTextInput';
import AppButton from '../../shared/components/app-button/AppButton';
import {
  getRecentTransactionsApi,
  makePayment,
  uploadDocForMakePayment,
} from '../../api/profileApi';
import AppDatePicker from '../../shared/components/app-date-picker/AppDatePicker';
import { getValueFromAppConfig } from '../../shared/helper-utils/localStorage';
import AppNumberInput from '../../shared/components/app-number-input/AppNumberInput';
import AppAlert from '../../shared/components/app-alert/AppAlert';
import {
  API_DATE_FORMAT,
  NAVIGATION_ROUTES,
  TODAY_DATE,
} from '../../shared/constants/Constants';
import {
  formatDate,
  getNewDate,
  isEmpty,
} from '../../shared/helper-utils/appUtils';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import AppLink from '../../shared/components/app-link/AppLink';
import AccountsPageHorizontalBar from './accounts/AccountsPageHorizontalBar';

function OfflineBalanceUpload() {
  const intl = useIntl();
  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };
  const navigate = useNavigate();
  const [transactionsList, setTransactionsList] = useState([]);
  const [banksList, setBanksList] = useState([]);
  const [bankOptions, setBankOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [validationError, setValidationError] = useState(false);
  const [alert, setAlert] = useState(undefined);
  const [receiptRequest, setReceiptRequest] = useState({
    pgname: 'techprocess2',
    payment_mode: 'Cheque',
    deposited_bank: '',
    deposited_branch: '',
    cheque_dd_no: '',
    cheque_dd_date: getNewDate(TODAY_DATE),
    deposited_amount: '',
    details: '',
    deposited_account: '',
    depositedby_accountnumber: '',
    depositedby_accountname: '',
    spare1: '',
  });

  const PAYMENT_OPTIONS = [
    { label: formattedMessage('cheque'), value: 'Cheque' },
    { label: formattedMessage('cash_deposit'), value: 'Cash Deposit' },
    { label: formattedMessage('online_transfer'), value: 'Online Transfer' },
    { label: formattedMessage('upi'), value: 'UPI' },
    { label: formattedMessage('rtgs'), value: 'RTGS' },
    { label: formattedMessage('neft'), value: 'NEFT' },
    { label: formattedMessage('imps'), value: 'IMPS' },
    {
      label: formattedMessage('same_bank_transfer'),
      value: 'Same Bank Transfer',
    },
  ];

  const checkValidName = (name) => {
    return (
      name?.toString()?.trim() !== '' && /^[a-zA-Z ]*$/.test(name) === false
    );
  };

  const getRecentTransactions = async () => {
    const response = await getRecentTransactionsApi();
    if (response?.Root?.Status === 'OK') {
      if (response.Root.Result !== '') {
        let { Receipt } = response.Root.Result;
        Receipt = Array.isArray(Receipt) ? Receipt : [Receipt];
        setTransactionsList(Receipt);
      }
    }
  };

  const getBankDetails = () => {
    const banks = getValueFromAppConfig('bankdetailshtml').split('~');
    const banksArray = banks.map((bank) => bank.split(','));
    setBanksList(banksArray);
    const depositBanks = getValueFromAppConfig('bankdropdown').split(':::');
    const depositBanksArray = depositBanks.map((bank) => ({
      label: bank,
      value: bank,
    }));
    setBankOptions(depositBanksArray);
  };

  useEffect(() => {
    getRecentTransactions();
    getBankDetails();
  }, []);

  const handleUpdateState = (name, value) => {
    let validInput = value;
    if (
      [
        'deposited_bank',
        'deposited_branch',
        'cheque_dd_no',
        'depositedby_accountname',
        'depositedby_accountnumber',
        'details',
      ].indexOf(name) > -1
    ) {
      const validCharactersPattern = /[^A-Za-z0-9\s.-]/g;
      validInput = validInput.replace(validCharactersPattern, '');
    }
    setReceiptRequest((prev) => ({
      ...prev,
      [name]: validInput,
    }));
  };
  function OptionField({ name, value }) {
    return (
      <div className="d-flex flex-column">
        <span className="recent-transaction_field-name">{name}</span>
        {typeof value !== 'object' && (
          <span className="recent-transaction_field-value">{value}</span>
        )}
      </div>
    );
  }

  const handleMoneyDeposit = async () => {
    setIsLoading(true);
    if (
      receiptRequest.payment_mode === '' ||
      receiptRequest.cheque_dd_no === '' ||
      receiptRequest.depositedby_accountnumber === '' ||
      receiptRequest.depositedby_accountname === '' ||
      receiptRequest.deposited_bank === '' ||
      receiptRequest.deposited_branch === '' ||
      receiptRequest.deposited_amount === '' ||
      receiptRequest.cheque_dd_date === '' ||
      receiptRequest.deposited_account === '' ||
      receiptRequest.spare1 === '' ||
      checkValidName(receiptRequest.depositedby_accountname)
    ) {
      setValidationError(true);
      setIsLoading(false);
      return false;
    }
    if (parseInt(receiptRequest.deposited_amount, 10) === 0) {
      setAlert({
        variant: 'error',
        title: 'Offline Payment',
        description: formattedMessage('zero_amount_alert'),
      });
      setIsLoading(false);
      return false;
    }
    if (
      receiptRequest.payment_mode === 'Cash Deposit' &&
      parseInt(receiptRequest.deposited_amount, 10) >= 200000
    ) {
      setAlert({
        variant: 'error',
        title: 'Offline Payment',
        description: 'Maximum amount for deposit is 2 lakhs',
      });
      setIsLoading(false);
      return false;
    }

    const formattedDate = formatDate(
      getNewDate(receiptRequest.cheque_dd_date),
      API_DATE_FORMAT,
    );
    const reqObj = {
      deposited_amount: receiptRequest.deposited_amount,
      pgname: receiptRequest.pgname,
      deposited_bank: receiptRequest.deposited_bank,
      deposited_branch: receiptRequest.deposited_branch,
      cheque_dd_no: receiptRequest.cheque_dd_no,
      cheque_dd_date: formattedDate,
      details: receiptRequest.details,
      payment_mode: receiptRequest.payment_mode,
      spare1: receiptRequest.spare1,
      account_depositedto: receiptRequest.deposited_account,
      depositedby_accountname: receiptRequest.depositedby_accountname,
      depositedby_accountnumber: receiptRequest.depositedby_accountnumber,
    };
    const response = await makePayment(reqObj);
    if (response && response?.ApiStatus?.Status === 'OK') {
      setAlert({
        variant: 'sucess',
        title: 'Offline Payment',
        description: `${response?.ApiStatus?.Message} , ${formattedMessage(
          'navigating_to_receipt_page',
        )}`,
      });
      setTimeout(() => {
        let route = NAVIGATION_ROUTES.TOP_UP_RECEIPT;
        route = route.replace(':transactionId', response?.ApiStatus?.Result);
        navigate(route);
      }, 2000);
    } else {
      setAlert({
        variant: 'Error',
        title: 'Offline Payment',
        description: response?.ApiStatus?.Message,
      });
    }

    setIsLoading(false);
  };

  const handleFileUpload = async (event) => {
    setAlert(undefined);
    const input = event.target;
    const file = input.files?.[0];
    const maxSize = 4 * 1024 * 1024;
    if (!file) return;
    const allowedTypes = [
      'image/jpeg',
      'image/jpg',
      'image/png',
      'application/pdf',
    ];
    if (!allowedTypes.includes(file.type)) {
      setAlert({
        variant: 'error',
        title: 'Upload',
        description: 'Only images and PDFs are allowed.',
      });
      input.value = '';
      return;
    }
    if (file.size > maxSize) {
      setAlert({
        variant: 'error',
        title: formattedMessage('file_upload'),
        description: 'File size should not exceed 4 MB.',
      });
      input.value = '';
      return;
    }
    try {
      setIsLoading(true);
      const formData = new FormData();
      formData.append('file', file);
      formData.append('uploadtype', receiptRequest.payment_mode);
      const response = await uploadDocForMakePayment(formData);
      if (response.status === 'OK') {
        const imageUrl = response.result;
        handleUpdateState('spare1', imageUrl);
      } else {
        setAlert({
          variant: 'error',
          title: formattedMessage('file_upload'),
          description:
            response?.ApiStatus?.Message ||
            formattedMessage('document_upload_failure_alert'),
        });
        input.value = '';
      }
    } catch (error) {
      setAlert({
        variant: 'error',
        title: formattedMessage('file_upload'),
        description: formattedMessage('document_upload_failure_alert'),
      });
      input.value = '';
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <AccountsPageHorizontalBar selectedPage="offline-payment" />
      <section className="money-deposit-page">
        <AppLoading isLoading={isLoading} />
        {alert && (
          <AppAlert
            showIcon
            variant={alert.variant}
            title={alert.title}
            onHide={() => setAlert(undefined)}
            description={alert.description}
          />
        )}
        <div className="money-deposit-page_container">
          <div className="money-deposit-page_header">Offline Payment</div>
          <Row className="payment-options-container p-3">
            <Col lg={8} md={8} sm={12} xs={12}>
              <Row className="spacing-16">
                <Col lg={6} md={6} sm={6} xs={12}>
                  <AppSelect
                    label={formattedMessage('payment_mode')}
                    name="payment_mode"
                    id="payment_mode"
                    placeholder=""
                    required
                    options={PAYMENT_OPTIONS}
                    selectedValue={receiptRequest.payment_mode}
                    onSelect={(dataObj) =>
                      handleUpdateState('payment_mode', dataObj.value)
                    }
                    isClearable={false}
                    errorText={
                      validationError &&
                      formattedMessage('payment_mode_validation')
                    }
                  />
                </Col>
                <Col lg={6} md={6} sm={6} xs={12}>
                  <AppTextInput
                    label={formattedMessage('cheque_transaction_ref_no')}
                    placeholderText=""
                    value={receiptRequest.cheque_dd_no}
                    onChange={(e) =>
                      handleUpdateState('cheque_dd_no', e.target.value)
                    }
                    errorText={
                      validationError &&
                      formattedMessage('cheque_tx_ref_validation')
                    }
                    required
                  />
                </Col>
                <Col lg={6} md={6} sm={6} xs={12}>
                  <AppTextInput
                    label={formattedMessage('ac_number')}
                    placeholderText=""
                    value={receiptRequest.depositedby_accountnumber}
                    onChange={(e) =>
                      handleUpdateState(
                        'depositedby_accountnumber',
                        e.target.value,
                      )
                    }
                    errorText={
                      validationError &&
                      formattedMessage('ac_number_validation')
                    }
                    required
                  />
                </Col>
                <Col lg={6} md={6} sm={6} xs={12}>
                  <AppTextInput
                    label={formattedMessage('ac_holder_name')}
                    placeholderText=""
                    value={receiptRequest.depositedby_accountname}
                    onChange={(e) =>
                      handleUpdateState(
                        'depositedby_accountname',
                        e.target.value,
                      )
                    }
                    errorText={
                      validationError &&
                      formattedMessage('ac_holder_name_validation')
                    }
                    required
                  />
                  {checkValidName(receiptRequest.depositedby_accountname) &&
                    !isEmpty(receiptRequest.depositedby_accountname) && (
                      <small className="app-error-text">
                        {formattedMessage('name_validation')}
                      </small>
                    )}
                </Col>
                <Col lg={6} md={6} sm={6} xs={12}>
                  <AppTextInput
                    label={formattedMessage('deposited_bank')}
                    placeholderText=""
                    value={receiptRequest.deposited_bank}
                    onChange={(e) =>
                      handleUpdateState('deposited_bank', e.target.value)
                    }
                    errorText={
                      validationError &&
                      formattedMessage('enter_deposited_bank')
                    }
                    required
                  />
                </Col>
                <Col lg={6} md={6} sm={6} xs={12}>
                  <AppTextInput
                    label={formattedMessage('deposited_branch')}
                    placeholderText=""
                    value={receiptRequest.deposited_branch}
                    onChange={(e) =>
                      handleUpdateState('deposited_branch', e.target.value)
                    }
                    errorText={
                      validationError &&
                      formattedMessage('deposited_branch_validation')
                    }
                    required
                  />
                </Col>
                <Col lg={6} md={6} sm={6} xs={12}>
                  <AppNumberInput
                    label="Deposit Amount"
                    placeholderText=""
                    value={receiptRequest.deposited_amount}
                    onChange={(d) => handleUpdateState('deposited_amount', d)}
                    errorText={
                      validationError &&
                      formattedMessage('amount_deposit_validation')
                    }
                    required
                  />
                </Col>
                <Col lg={6} md={6} sm={6} xs={12}>
                  <AppDatePicker
                    label={formattedMessage('deposit_date')}
                    placeholder=""
                    maxDate={getNewDate(TODAY_DATE)}
                    customClassName="position-relative"
                    labelClassName="money-deposit-label"
                    selectedDate={receiptRequest.cheque_dd_date}
                    onChange={(date) =>
                      handleUpdateState('cheque_dd_date', date)
                    }
                    errorText={
                      validationError &&
                      formattedMessage('deposite_date_vaidation')
                    }
                  />
                </Col>
                <Col lg={6} md={6} sm={6} xs={12}>
                  <AppSelect
                    label={formattedMessage('our_bank_accounts')}
                    isClearable={false}
                    name="bank_accounts"
                    placeholder="Select"
                    options={bankOptions}
                    selectedValue={receiptRequest.deposited_account}
                    onSelect={(d) =>
                      handleUpdateState('deposited_account', d.value)
                    }
                    required
                    errorText={validationError && 'Select Bank Account'}
                  />
                </Col>
                <Col lg={6} md={6} sm={6} xs={12} className="d-flex">
                  <textarea
                    placeholder="Remarks"
                    style={{
                      maxHeight: '48px',
                      border: '1px solid rgb(221, 221, 221)',
                      borderRadius: '6px',
                    }}
                    className="flex-1"
                    value={receiptRequest.details}
                    onChange={(e) =>
                      handleUpdateState('details', e.target.value)
                    }
                  />
                </Col>
              </Row>
              <div className="gap-1 d-flex">
                <div className=" gap-2 my-2 fs-14">
                  <label
                    htmlFor="upload_file"
                    className="secondary-text required"
                  >
                    Upload cheque/DD copy{' '}
                    <span style={{ color: 'red' }}>*</span>
                  </label>
                  <input
                    type="file"
                    accept="image/*,.pdf,.docx,.xlsx"
                    className="file-upload border border-primary mt-2 mb-2"
                    name="upload-file"
                    id="upload_file"
                    onChange={handleFileUpload}
                    style={{
                      width: '100%',
                      maxWidth: '100%',
                      boxSizing: 'border-box',
                    }}
                  />
                  <span className="secondary-text">
                    {formattedMessage('max_size_allowed_types')}
                  </span>
                  {validationError && receiptRequest.spare1 === '' && (
                    <small className="app-error-text d-block mt-1">
                      Please upload a document
                    </small>
                  )}
                  {receiptRequest.spare1 !== '' &&
                    receiptRequest.spare1 !== null && (
                      <a
                        style={{ display: 'block', fontSize: 12 }}
                        rel="noopener noreferrer"
                        target="_blank"
                        href={receiptRequest.spare1}
                      >
                        {formattedMessage('click_here_to_view_upload_file')}
                      </a>
                    )}
                </div>
              </div>

              <div className="d-flex justify-content-center mt-2">
                <AppButton
                  btnText="Submit"
                  className="px-5"
                  onClick={handleMoneyDeposit}
                  variant="primary"
                />
              </div>
            </Col>
            <Col
              lg={4}
              md={4}
              sm={12}
              xs={12}
              className="bank-details-table p-2"
            >
              <table className="w-100">
                <thead>
                  <tr>
                    <th>BANK DETAILS</th>
                  </tr>
                </thead>
                <tbody>
                  {banksList.map((bank) => (
                    <React.Fragment key={bank[4]}>
                      <tr>
                        <td>Bank Name</td>
                        <td>: {bank[0]}</td>
                      </tr>
                      <tr>
                        <td>Account Name</td>
                        <td> : {bank[1]}</td>
                      </tr>
                      <tr>
                        <td>Branch</td>
                        <td>: {bank[2]}</td>
                      </tr>
                      <tr>
                        <td>IFSC Code</td>
                        <td>: {bank[3]}</td>
                      </tr>
                      <tr>
                        <td>A/C Number</td>
                        <td>: {bank[4]}</td>
                      </tr>
                      <tr className="mb-3">
                        <td className="pb-3">PAN</td>
                        <td className="pb-3">: {bank[5]}</td>
                      </tr>
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
              {getValueFromAppConfig('OFFLINEPAYMENTNOTE') === 'true' && (
                <p className="fs-12 pt-5">
                  *Cash deposits attract an additional 1% charge. Maximum
                  permitted cash deposit is ₹1,90,000. Any excess amount may be
                  forfeited, and no claim will be accepted.
                </p>
              )}
            </Col>
          </Row>
          <div className="recent-transactions-container mt-3">
            <div>
              {transactionsList &&
                transactionsList.map((report) => (
                  <Row
                    className="recent-transactions-card spacing-0 p-2 mb-2"
                    key={report.Txid}
                  >
                    <Col lg={2} md={2} sm={3} xs={6}>
                      <OptionField name="Txid" value={report.Txid} />
                    </Col>
                    <Col lg={2} md={2} sm={3} xs={6}>
                      <OptionField name="TxDate" value={report.TxDate} />
                    </Col>
                    <Col lg={2} md={2} sm={3} xs={6}>
                      <OptionField
                        name="PaymentMode"
                        value={report.PaymentMode}
                      />
                    </Col>
                    <Col lg={2} md={2} sm={3} xs={6}>
                      <OptionField
                        name="Deposited Bank"
                        value={report?.DepositedBank}
                      />
                    </Col>
                    <Col lg={2} md={2} sm={3} xs={6}>
                      <OptionField
                        name="Deposited Branch"
                        value={report.DepositedBranch}
                      />
                    </Col>
                    <Col lg={2} md={2} sm={3} xs={6}>
                      <OptionField
                        name="Cheque DDNo"
                        value={report.ChequeDDNo}
                      />
                    </Col>
                    <Col lg={2} md={2} sm={3} xs={6}>
                      <OptionField
                        name="ChequeDD Date"
                        value={report.ChequeDDDate}
                      />
                    </Col>
                    <Col lg={2} md={2} sm={3} xs={6}>
                      <OptionField
                        name="Deposited Amount"
                        value={report.DepositedAmount}
                      />
                    </Col>
                    <Col lg={2} md={2} sm={3} xs={6}>
                      <OptionField
                        name="Account DepositedTo"
                        value={report.AccountDepositedTo}
                      />
                    </Col>
                    <Col lg={2} md={2} sm={3} xs={6}>
                      <OptionField
                        name="Approved Amount"
                        value={report.ApprovedAmount}
                      />
                    </Col>
                    <Col lg={2} md={2} sm={3} xs={6}>
                      <OptionField
                        name="Approval Date"
                        value={report.ApprovalDate}
                      />
                    </Col>
                    <Col lg={1} md={2} sm={3} xs={6}>
                      <OptionField name="AgentId" value={report.AgentId} />
                    </Col>
                    <Col lg={1} md={2} sm={3} xs={6}>
                      <OptionField name="Status" value={report.Status} />
                    </Col>
                  </Row>
                ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default OfflineBalanceUpload;
